import { Footer } from "@components/site/Footer"
import { Header } from "@components/site/Header"
import { ScrollRestoration } from "eddev/routing"
import { defineView } from "eddev/views"

export default defineView("_app", (props) => {
  return (
    <>
      <ScrollRestoration />
      <div className="relative">
        {props.children}
        <Footer />
      </div>
    </>
  )
})
